import React from "react";
import { Reveal, RevealGroup, RevealItem } from "@/components/motion/Reveal";

const steps = [
  { num: "01", title: "Inicio del proyecto", desc: "Reunión inicial para conocer tu marca, objetivos, público y presupuesto. Firma de NDA y envío de propuesta técnica." },
  { num: "02", title: "Especificaciones técnicas", desc: "Definición de las especificaciones técnicas del producto según los requisitos del cliente." },
  { num: "03", title: "Formulación del producto", desc: "El equipo de I+D desarrolla el producto: pruebas de estabilidad, saborización y prueba industrial." },
  { num: "04", title: "Marketing y diseño", desc: "Asesoramiento en packaging, imagen de marca y diseño de etiqueta." },
  { num: "05", title: "Registro y etiquetado", desc: "Acompañamiento regulatorio conforme a la normativa alimentaria nacional y europea." },
  { num: "06", title: "Producción y envasado", desc: "Fabricación y envasado del producto bajo estricto control de calidad." },
  { num: "07", title: "Logística y entrega", desc: "Almacenamiento propio y preparación de pedidos. *Para servicios personalizados, consultar condiciones." },
];

const WAREHOUSE = "https://customer-assets.emergentagent.com/job_athletic-fuel-3/artifacts/71bpw2rs_Captura%20de%20pantalla%202026-07-08%20a%20las%2012.42.59.png";

const MOSAIC = [
  "https://customer-assets.emergentagent.com/job_athletic-fuel-3/artifacts/exx8u4z3_Captura%20de%20pantalla%202026-07-09%20a%20las%2010.38.20.png",
  "https://customer-assets.emergentagent.com/job_athletic-fuel-3/artifacts/oc9ihpfv_Captura%20de%20pantalla%202026-07-09%20a%20las%2010.24.22.png",
  "https://customer-assets.emergentagent.com/job_athletic-fuel-3/artifacts/pn4v6sse_Captura%20de%20pantalla%202026-07-09%20a%20las%2010.22.54.png",
  "https://customer-assets.emergentagent.com/job_athletic-fuel-3/artifacts/xovrxhog_Captura%20de%20pantalla%202026-07-08%20a%20las%2012.46.11.png",
  "https://customer-assets.emergentagent.com/job_athletic-fuel-3/artifacts/yf705l4w_Captura%20de%20pantalla%202026-07-08%20a%20las%2012.45.06.png",
];

export default function Process() {
  return (
    <section id="proceso" className="relative py-10 md:py-14 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-stretch">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-[#0A84E2] font-semibold mb-4">/ 06 · Cómo trabajamos</div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0A1628] uppercase tracking-tighter leading-[1]">
              De la idea <span className="text-[#0A84E2]">a tu marca.</span>
            </h2>
            <p className="mt-6 text-slate-600 text-lg">Un proceso transparente y probado. Te acompañamos en cada fase del desarrollo, desde el briefing inicial hasta la entrega internacional.</p>
            <div className="mt-10 rounded-sm overflow-hidden border border-slate-200 shadow-lg">
              <img src={WAREHOUSE} alt="Instalaciones industriales Global Nutralabs" className="w-full h-64 object-cover" />
            </div>

            {/* Animated mosaic — our facilities & production */}
            <RevealGroup stagger={0.09} className="mt-4 grid grid-cols-2 gap-4">
              <RevealItem className="col-span-2">
                <div className="group relative overflow-hidden rounded-sm border border-slate-200 shadow-sm">
                  <img
                    src={MOSAIC[0]}
                    alt="Proceso de fabricación Global Nutralabs"
                    data-testid="process-mosaic-0"
                    className="w-full h-44 md:h-52 object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-[#0A1628]/0 group-hover:bg-[#0A1628]/10 transition-colors duration-500" />
                </div>
              </RevealItem>
              {MOSAIC.slice(1).map((src, i) => (
                <RevealItem key={i}>
                  <div className="group relative overflow-hidden rounded-sm border border-slate-200 shadow-sm">
                    <img
                      src={src}
                      alt={`Instalaciones Global Nutralabs ${i + 2}`}
                      data-testid={`process-mosaic-${i + 1}`}
                      className="w-full h-32 md:h-40 object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-[#0A1628]/0 group-hover:bg-[#0A1628]/10 transition-colors duration-500" />
                  </div>
                </RevealItem>
              ))}
            </RevealGroup>
          </div>

          <div className="lg:col-span-7 flex flex-col justify-between gap-3">
            {steps.map((s) => (
              <div key={s.num} data-testid={`process-step-${s.num}`} className="corp-card rounded-sm p-6 md:p-7 flex gap-6 flex-1 items-center">
                <div className="font-display text-3xl md:text-4xl font-extrabold text-[#0A84E2] leading-none min-w-[56px]">{s.num}</div>
                <div className="flex-1">
                  <h3 className="font-display text-lg md:text-xl font-semibold text-[#0A1628]">{s.title}</h3>
                  <p className="mt-1.5 text-slate-600 leading-relaxed text-sm md:text-base">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
